<!--
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-09 16:07:56
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-26 17:40:38
 * @FilePath: \fe-frame-page\src\views\enterpriseHighNewN\components\fullVersion.vue
 * @Description: 基础版测评页
-->
<template>
  <div class="enterprise-high">
    <!-- 头部 -->
    <div class="header-box">
      <div class="right-box">
        <div @click="handleFullVersion">
          <svg-icon icon-class="handoff"></svg-icon>补充信息测评更精确
        </div>
      </div>
      <div class="title">国家高新技术企业测评</div>
      <div class="desc">
        企业税收优惠、科技扶持政策门槛、企业品牌提升、上市重要条件
      </div>
      <div class="input">
        <!-- <a-input-search
          placeholder="请输入企业名称，如“汉唐信通技术有限公司"
          @search="onSearch"
          size="large"
        >
          <a-button slot="enterButton">
            <svg-icon icon-class="search_blue" class="icon"></svg-icon>
            开始测评
          </a-button>
        </a-input-search> -->
        <a-select
          show-search
          :value="companyName"
          :autoClearSearchValue="false"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="optionLoading ? undefined : null"
          @search="handleSearch"
          @change="handleChange"
          style="width: 400px"
          placeholder="请输入企业名称，如“汉唐信通（北京）咨询股份有限公司”"
        >
          <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
          <a-select-option
            v-for="(company, index) in companyList"
            :key="index"
            :value="company"
            >{{ company }}</a-select-option
          >
        </a-select>
        <a-button @click="onSearch" :loading="loading">
          <svg-icon icon-class="search_blue" class="icon"></svg-icon>
          开始测评
        </a-button>
      </div>
    </div>
    <div class="content-list">
      <div
        class="item"
        v-for="(item, index) in contentList"
        :key="index"
        :style="{ background: 'url(' + item.icon + ') no-repeat' }"
      >
        <div class="question">
          <div class="doc"></div>
          <div class="doc"></div>
          <div class="doc"></div>
          {{ item.question }}
          <div class="doc"></div>
          <div class="doc"></div>
          <div class="doc"></div>
        </div>
        <div class="answer">{{ item.answer }}</div>
      </div>
    </div>

    <!-- 未满一年提示弹窗 -->
    <not-full-model :visible.sync="notFullVisible" />
  </div>
</template>
<script>
import NotFullModel from "./notFullModel.vue";
import { throttle } from "lodash-es";
import {
  getCompanyInfo,
  getCorpInfo,
  highTechEnterpriseEvaBasis,
} from "@/api/enterpriseHighNew";
export default {
  name: "enterpriseHigh",
  components: {
    NotFullModel,
  },
  data() {
    return {
      contentList: [
        {
          question: "什么是高新技术企业",
          answer:
            "国家高新技术企业又称国家级高新技术企业，根据《高新技术企业认定管理办法》规定，国家高新技术企业是指在《国家重点支持的高新技术领域》内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展经营活动，在中国境内（不包括港、澳、台地区）注册一年以上的居民企业。",
          icon: require("@/assets/images/gx_1.svg")
        },
        {
          question: "高新技术企业认定的好处",
          answer:
            "一、税收减免：经认定的高新技术企业，可执行15%（认定前25%）的优惠税率，税率降低10个点，税额减少40%。二、直接奖励：获得高新后，可获得地方资金奖励（最多的有百万）。三、融资贷款：更容易获得VC的投资和各大银行的贷款。四、资助基础：是其他申报各类型政府专项资金的首要条件之一。五、品牌提升：科技类企业唯一“国”字招牌企业荣誉，电子商务时代极大利于促进企业异地成交，是企业实力的最佳象征。六、吸引人才：科技创业的核心是优秀人才，这样更能吸引他们。七、办公改善：优先获得办公及工业用地，很多地方还可以免费用地。八、政府采购：高新技术企业产品优先纳入政府采购体系。九、资产折旧：固定资产加速折旧，对财务报表有利。十、企业上市：创业板，新三板上市的重要条件之一。",
          icon: require("@/assets/images/gx_2.svg")
        },
        {
          question: "高新技术企业认定的必要",
          answer:
            "一、促进企业科技转型：高新技术企业认定目的之一为了引导企业调整产业结构，走自主创新、持续创新的发展道路，激发企业自主创新的热情，提高科技创新能力。二、提升企业品牌形象：通过高新技术认定的企业是国家重点支持的具有高成长性的企业，具有较好的潜在经济效益。三、享受税收减免优惠政策：全国多地针对高新技术企业有专门的税收优惠政策。四、提升产品附加值：高新技术企业具有较强的技术创新能力、高端技术开发能力，作为很多招投标的重要条件。五、提高企业资本价值：高新技术企业是地方政府、行业组织对企业实施优惠政策和资金扶持的重要条件。六、资本市场加分：高新技术企业深受投资机构和金融机构青睐。",
          icon: require("@/assets/images/gx_2.svg")
        },
        // {
        //   question: '高新技术企业测评的流程',
        //   answer: '输入企业名称即可获取报告，补充信息测评更精确（高总，说这里她在编点）',
        //   icon: '/src/assets/images/highTech/gx_4.svg'
        // },
        {
          question: "高新技术企业测评的好处",
          answer:
            "高新技术企业测评解决如下难题：一、不清楚自己的公司是否符合国家高新技术企业认证的标准。二、不知道国家高新企业技术企业认证的申报关键点。三、新政策下国家高新企业认证申请有哪些注意点。",
          icon: require("@/assets/images/gx_5.svg")
        },
      ],
      notFullVisible: false, // 未满一年弹窗
      consultVisible: false, // 留咨弹窗
      optionLoading: false,
      companyList: [],
      companyName: undefined, // 公司名称
      foundedTime: "", // 成立日期
      loading: false,
    };
  },

  methods: {
    // 去完成版测评
    handleFullVersion() {
      // this.$emit("onFullVersion", this.companyName);
      if (this.companyName) {
        this.$router.push(
          `/enterpriseHighNew?type=full&companyName=${this.companyName}`
        );
      } else {
        this.$router.push(`/enterpriseHighNew?type=full`);
      }
    },
    handleChange(value) {
      this.companyName = value;
      Object.assign(this, {
        companyList: [],
        optionLoading: false,
      });
      // getCorpInfo({
      //   companyName: value,
      // }).then((res) => {
      //   if (res.data.name) {
      //     this.foundedTime = res.data.foundedTime;
      //   }
      // });
    },
    handleSearch: throttle(function (value) {
      if (!value) {
        return;
      }
      this.optionLoading = true;
      // this.companyName = value;
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyList = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    }, 1000),
    // 判断是否满一年
    isFullYear() {
      return new Promise((resolve) => {
        getCorpInfo({
          companyName: this.companyName,
        }).then((res) => {
          if (res.data.name) {
            let date = res.data.foundedTime;
            if (
              (new Date().getTime() - new Date(date).getTime()) /
                (24 * 60 * 60 * 1000) >
              365
            ) {
              resolve(true);
            } else {
              this.notFullVisible = true;
              resolve(false);
            }
          } else {
            this.$message.warning("暂未查询到相关信息，建议您重新输入");
            resolve(false);
          }
        });
      });
    },

    async onSearch() {
      if (!this.companyName) {
        this.$message.error("请输入企业名称");
        return;
      }
      this.loading = true;
      let isFull = await this.isFullYear();
      if (!isFull) {
        this.loading = false;
        return;
      }
      let res = await highTechEnterpriseEvaBasis({
        companyName: this.companyName,
      });
      if (res.code == 0) {
        this.$router.push({
          path: `/enterpriseHighNew/result`,
          query: {
            type: "base",
            reportId: res.data.reportId,
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.enterprise-high {
  background: #fff;
  box-shadow: 0px 2px 9px 0px rgba(249, 249, 249, 0.5);
  border: 1px solid #eeeeee;
  .header-box {
    width: 100%;
    height: 240px;
    background: url("../../../assets/images/gx-bg1.svg") no-repeat;
    background-size: cover;
    background-position: center;
    .right-box {
      display: flex;
      justify-content: flex-end;
      margin-right: 24px;
      padding-top: 26px;
      font-size: 16px;
      color: #ffffff;
      > div {
        cursor: pointer;
      }
      svg {
        margin-right: 4px;
      }
    }
    .title {
      height: 32px;
      font-size: 32px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 32px;
      margin-top: 12px;
      text-align: center;
    }
    .desc {
      height: 14px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 14px;
      margin-top: 14px;
      text-align: center;
    }
    .input {
      width: 924px;
      margin: 0 auto;
      margin-top: 22px;
      border: 4px solid rgba(255, 255, 255, 0.09);
      border-radius: 4px;
      // margin-top: 22px;
      // padding: 0 112px;
      display: flex;
      justify-content: center;
      ::v-deep .ant-select {
        flex: 1;
      }
      ::v-deep .ant-select-selection--single {
        height: 50px;
        border-radius: 4px 0 0 4px;
        border: 4px solid rgba(255, 255, 255, 0.09);
      }
      .icon {
        width: 20px;
        height: 21px;
        margin-right: 4px;
      }

      ::v-deep
        .ant-select-show-search.ant-select:not(.ant-select-customize-input)
        .ant-select-selector
        input {
        line-height: 40px;
        height: 40px;
      }
      ::v-deep .ant-select-no-arrow .ant-select-selection__rendered {
        line-height: 40px;
      }
    }
    ::v-deep .ant-btn {
      background: #ffffff;
      border-left: 1px solid #f4f4f4;
      color: #3371ff;
      border-radius: 0 4px 4px 0;
      height: 50px;
      width: 143px;
      font-size: 16px;
      border: none;
      border-left: 1px solid #f4f4f4;
    }
    ::v-deep .ant-input-lg {
      padding: 14px 10px;
      font-size: 14px;
    }
  }
  .content-list {
    .item {
      width: 1106px;
      min-height: 190px;
      background: #ffffff;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.04),
        0px -2px 14px 0px rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      margin: 10px auto;
      padding: 0 24px 44px 24px;
      position: relative;
      background-position: right bottom !important;
      .icon {
        position: absolute;
        width: 205px;
        height: 132px;
        right: 0;
        bottom: 0;
      }
      .question {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
        padding-top: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        .doc {
          background: #4471ff;
          opacity: 0.14;
          border-radius: 50%;
          margin-right: 10px;
          &:nth-child(1),
          &:nth-child(6) {
            width: 4px;
            height: 4px;
          }
          &:nth-child(2),
          &:nth-child(5) {
            width: 6px;
            height: 6px;
          }
          &:nth-child(3),
          &:nth-child(4) {
            width: 8px;
            height: 8px;
          }
          &:nth-child(4) {
            margin-left: 10px;
          }
        }
      }
      .answer {
        // height: 59px;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        margin-top: 24px;
      }
    }
  }
}
</style>